import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from '../../../../features/ui/types'

export const StyledFooterContainer = styled.div<{ mode: Theme; displayBorder: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 6px;
  border-top: ${({ displayBorder, mode }) =>
    displayBorder ? `1px solid ${sys[mode].common.divider[100]}` : 'none'};
  cursor: pointer;
`

export const StyledFooterLeft = styled.div`
  margin-right: 6px;
`

export const StyledFooterRight = styled.div<{ mode: Theme }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // to set ellipsis dot color
  color: ${({ mode }) => sys[mode].text.placeholder};
`

export const StyledFooterItem = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:not(:last-child) {
    margin-right: 6px;
  }
`

export const StyledFooterItemIcon = styled.div``

export const StyledFooterItemValue = styled.div<{ mode: Theme }>`
  color: ${({ mode }) => sys[mode].text.placeholder};
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[12].size};
  margin-left: 4px;
`
